<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"></v-progress-circular>
  <div v-else class="UpdateCustomer">
    <h1 class="text-center">Update customer profile</h1>
    <div class="form-edit">
      <div class="row w-70">
        <div class="col mr-10">
          <label for="customerCode">Customer code</label>
          <input
            id="customerCode"
            class="form-control"
            type="text"
            v-model="customerCode"
            readonly
          />
        </div>
        <div class="col"></div>
      </div>
      <div class="row w-70">
        <div class="col mr-10">
          <label for="firstName">Firstname</label>
          <input
            id="firstName"
            class="form-control"
            :class="{
              'input--error':
                isSubmit && ($v.firstName.$invalid || error.errFirstName),
            }"
            type="text"
            v-model="firstName" />
          <div v-if="isSubmit && error.errFirstName" class="text-error">
            {{ error.errFirstName.message }}
          </div>
        </div>
        <div class="col">
          <label for="lastName">Lastname</label>
          <input
            id="lastName"
            class="form-control"
            :class="{
              'input--error':
                isSubmit && ($v.lastName.$invalid || error.errLastName),
            }"
            type="text"
            v-model="lastName" />
          <div v-if="isSubmit && error.errLastName" class="text-error">
            {{ error.errLastName.message }}
          </div>
        </div>
      </div>
      <div class="row w-70">
        <div class="col mr-10">
          <label for="selectGender">Gender</label>
          <b-form-select
            id="selectGender"
            class="form-control"
            v-model="selectGender"
            :options="listGenders"
          >
          </b-form-select>
        </div>
        <div class="col"></div>
      </div>
      <div class="row w-70">
        <div class="col mr-10">
          <label for="nationalId">ID card number/Passport number</label>
          <div class="text-right update-btn-group">
            <button
              v-if="checkAdminUser || checkBrandAdminUser"
              class="btn btn-outline-dark mr-3"
              @click="clearIdCard">
              Clear
            </button>
            <button class="btn btn-outline-dark" @click="showDialog = true">
              Update
            </button>
          </div>
          <input
            id="nationalId"
            class="form-control"
            v-model="nationalId"
            type="text"
            disabled
            :class="{
              'input--error': isSubmit && error.errNationalId,
            }"
          />
          <div v-if="isSubmit && error.errNationalId" class="text-error">
            {{ error.errNationalId.message }}
          </div>
        </div>
        <div class="col">
          <label for="birthday">Date of birth</label>
          <div class="text-right update-btn-group">
            <button class="btn btn-outline-dark" @click="showDateDialog = true">
              Update
            </button>
          </div>
          <input
            id="birthday"
            class="form-control"
            v-model="birthday"
            type="text"
            disabled
            :class="{
              'input--error': isSubmit && error.errBirthday,
            }"
          />
          <div v-if="isSubmit && error.errBirthday" class="text-error">
            {{ error.errBirthday.message }}
          </div>
        </div>
      </div>
      <div class="row w-70">
        <div class="col mr-10">
          <label for="mobile">Mobile</label>
          <input
            id="mobile"
            class="form-control"
            :class="{
              'input--error':
                isSubmit && ($v.mobile.$invalid || error.errMobile),
            }"
            type="text"
            v-model="mobile"
          />
          <div v-if="isSubmit && error.errMobile" class="text-error">
            {{ error.errMobile.message }}
          </div>
        </div>
        <div class="col">
          <label for="emailInput">Email</label>
          <input
            id="emailInput"
            class="form-control"
            type="text"
            v-model="email"
            :class="{ 'input--error': isSubmit && error.errEmail }" />
          <div v-if="isSubmit && error.errEmail" class="text-error">
            {{ error.errEmail.message }}
          </div>
        </div>
      </div>
      <div class="row w-70">
        <div class="col">
          <label for="address">Address</label>
          <input
            id="address"
            class="form-control"
            type="text"
            v-model="address"
          />
        </div>
      </div>
      <div class="row w-70">
        <div class="col mr-10">
          <div>Postcode</div>
          <ThailandAutoComplete
            v-model="zipcode"
            type="zipcode"
            placeholder="รหัสไปรษณีย์"
            @select="select" />
        </div>
        <div class="col">
          <div>Province</div>
          <ThailandAutoComplete
            v-model="province"
            type="province"
            placeholder="จังหวัด"
            @select="select" />
        </div>
      </div>
      <div class="row w-70">
        <div class="col mr-10">
          <div>District</div>
          <ThailandAutoComplete
            v-model="amphoe"
            type="amphoe"
            placeholder="อำเภอ"
            @select="select" />
        </div>
        <div class="col">
          <div>Sub-district</div>
          <ThailandAutoComplete
            v-model="district"
            type="district"
            placeholder="ตำบล"
            @select="select" />
        </div>
      </div>
      <div
        class="d-flex w-70 button-group"
        :class="{ 'mb-5': listPointBalance.length === 0 }">
        <button
          class="btn btn-outline-danger"
          @click="() => $router.push({ name: 'ListCustomerProfiles' })"
          :class="{ 'mr-5': checkAdminUser || checkBrandAdminUser }">
          Cancel
        </button>
        <button
          v-if="checkAdminUser || checkBrandAdminUser"
          class="btn btn-outline-success"
          @click="checkValidate">
          Save
        </button>
      </div>
      <div class="row w-70">
        <ListPointBalance :list="listPointBalance" />
      </div>
    </div>
    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <div class="text-center">
          <input class="form-control" v-model="dialogText" type="text" />
        </div>
        <div class="d-flex justify-content-evenly mt-5">
          <button class="btn btn-outline-dark" @click="hideDialog">ปิด</button>
          <button class="btn btn-outline-success" @click="saveDialog">
            บันทึก
          </button>
        </div>
      </div>
    </v-dialog>
    <v-dialog v-model="showDateDialog" width="500" persistent>
      <div class="content-dialog">
        <div class="text-center">
          <date-picker
            v-bind="$attrs"
            v-model="dateDialog"
            format="D MMMM yyyy"
            :value="dateDialog"
            lang="en"
            @change="dateDialog = $event" />
        </div>
        <div class="d-flex justify-content-evenly mt-5">
          <button class="btn btn-outline-dark" @click="hideDateDialog">
            ปิด
          </button>
          <button class="btn btn-outline-success" @click="saveDateDialog">
            บันทึก
          </button>
        </div>
      </div>
    </v-dialog>
    <v-dialog v-model="submitDialog" width="500" persistent>
      <div class="content-submit-dialog">
        <h3>{{ publicMsg }}</h3>
        <div class="text-center">
          <div v-if="showSuccess && id">
            <button class="btn-back" @click="setDefault">ตกลง</button>
          </div>
          <div v-if="showSuccess" class="mt-5">
            <button
                class="btn-back"
              @click="() => $router.push({ name: 'ListCustomerProfiles' })">
              กลับสู่หน้าหลัก
            </button>
          </div>
          <button
            v-if="!showSuccess"
            class="btn btn-outline-dark"
            @click="submitDialog = false">
            ปิด
          </button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import listNationality from "@/json/listNationality.json";
import ThailandAutoComplete from "vue-thailand-address-autocomplete";
import CustomerService from "@/services/api/customer.service.js";
import ListPointBalance from "./ListPointBalance.vue";
import { required } from "vuelidate/lib/validators";
const currYear = moment().format("YYYY");
export default {
  components: {
    ThailandAutoComplete,
    ListPointBalance,
  },
  data() {
    return {
      id: this.$route.query.id,
      firstName: null,
      lastName: null,
      nationalId: null,
      birthday: null,
      dialogText: null,
      dateDialog: moment(`${currYear}-01-01`)
        .add(-30, "years")
        .format("YYYY-MM-DD"),
      selectGender: null,
      mobile: null,
      email: null,
      address: null,
      listNationality: listNationality,
      listGenders: [
        {
          value: "MALE",
          text: "Male",
        },
        {
          value: "FEMALE",
          text: "Female",
        },
        {
          value: "OTHERS",
          text: "Others",
        },
      ],
      district: "",
      amphoe: "",
      province: "",
      zipcode: "",
      showDialog: false,
      showDateDialog: false,
      isLoading: false,
      submitDialog: false,
      showSuccess: false,
      publicMsg: null,
      error: {
        errFirstName: null,
        errLastName: null,
        errNationalId: null,
        errBirthday: null,
        errMobile: null,
        errEmail: null,
      },
      isSubmit: false,
      listPointBalance: [],
      customerCode: null,
      isChangeIdCard: false,
    };
  },
  validations: {
    firstName: {
      required,
    },
    lastName: {
      required,
    },
    selectGender: {
      required,
    },
    birthday: {
      required,
    },
    mobile: {
      required,
    },
  },
  computed: {
    ...mapGetters({
      userRoles: "account/getUserRoles",
    }),
    checkAdminUser() {
      return this.userRoles.includes("ROLE_ADMIN");
    },
    checkBrandAdminUser() {
      return this.userRoles.includes("ROLE_BRAND_ADMIN");
    },
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      this.isLoading = true;
      try {
        await CustomerService.getDetailCustomer(this.id)
          .then((res) => {
            this.isLoading = false;
            const data = res.data;
            const customer = data.customer;
            this.customerCode = customer.customerCode;
            this.firstName = customer.firstname;
            this.lastName = customer.lastname;
            this.nationalId = customer.nationalId;
            this.birthday = customer.birthday;
            this.selectGender = customer.gender?.name || "";
            this.mobile = customer.mobile;
            this.email = customer.email;
            this.address = customer.address;
            this.province = customer.province || "";
            this.amphoe = customer.district || "";
            this.district = customer.subDistrict || "";
            this.zipcode = customer.postalCode || "";
            this.listPointBalance = customer.customerPointBalance;
          })
          .catch((err) => {
            this.isLoading = false;
            console.log("Error: ", err);
          });
      } catch (error) {
        this.isLoading = false;
        console.log("Error: ", error);
      }
    },
    select(address) {
      this.district = address.district;
      this.amphoe = address.amphoe;
      this.province = address.province;
      this.zipcode = address.zipcode;
    },
    checkValidate() {
      this.isSubmit = true;
      if (this.$v.$invalid) {
        return;
      } else {
        this.isLoading = true;
        this.submitForm();
      }
    },
    async submitForm() {
      try {
        const body = {
          firstname: this.firstName,
          lastname: this.lastName,
          gender: this.selectGender.toLowerCase(),
          email: this.email,
          mobile: this.mobile,
          birthday: this.birthday.includes("X") ? null : this.birthday,
          nationalId: this.isChangeIdCard ? this.nationalId : undefined,
          address: this.address,
          province: this.province,
          district: this.amphoe,
          subDistrict: this.district,
          postalCode: this.zipcode,
        };
        await CustomerService.updateCustomerProfile(this.id, body)
          .then((res) => {
            const data = res.data;
            this.isLoading = false;
            this.isSubmit = false;
            if (data.status === "success") {
              this.showSuccess = true;
              this.publicMsg = data.message;
              this.showSubmitDialog();
            } else {
              this.showSuccess = false;
              this.isSubmit = true;
              if (Array.isArray(data.errors) && data.errors.length > 0) {
                this.setErrorText(data.errors);
              }else{
                this.publicMsg = "ไม่สามารถบันทึกได้";
                this.showSubmitDialog();
              }
            }
          })
          .catch((err) => {
            this.isLoading = false;
            console.log("Error: ", err);
          });
      } catch (ex) {
        this.isLoading = false;
        console.log("Error: ", ex);
      }
    },
    clearIdCard() {
      this.isChangeIdCard = true;
      this.nationalId = "";
    },
    setErrorText(errors) {
      this.error.errFirstName = errors.find((e) => e.fieldName === "firstname");
      this.error.errLastName = errors.find((e) => e.fieldName === "lastname");
      this.error.errNationalId = errors.find(
        (e) => e.fieldName === "nationalId"
      );
      this.error.errBirthday = errors.find((e) => e.fieldName === "birthday");
      this.error.errMobile = errors.find((e) => e.fieldName === "mobile");
      this.error.errEmail = errors.find((e) => e.fieldName === "email");
    },
    saveDialog() {
      if (this.dialogText) {
        this.isChangeIdCard = true;
        this.nationalId = this.dialogText;
      }
      this.hideDialog();
    },
    saveDateDialog() {
      if (this.dateDialog) {
        this.birthday = moment(this.dateDialog, "YYYY-MM-DD").format(
          "D/M/YYYY"
        );
      }
      this.hideDateDialog();
    },
    hideDialog() {
      this.dialogText = null;
      this.showDialog = false;
    },
    hideDateDialog() {
      this.dateDialog = null;
      this.showDateDialog = false;
    },
    showSubmitDialog() {
      this.submitDialog = true;
    },
    setDefault() {
      this.submitDialog = false;
      this.isSubmit = false;
    },
  },
  watch: {
    dialogText: {
      handler: function (val) {
        this.dialogText = val?.replaceAll(/\D/, "");
      },
      deep: true,
    },
    mobile: {
      handler: function (val) {
        this.mobile = val?.replaceAll(/\D/, "");
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.form-edit {
  left: 15%;
  position: relative;
}

.w-70 {
  width: 100%;
  max-width: 70%;
}

.update-btn-group {
  margin: 0.5rem 0;
}

.button-group {
  justify-content: flex-end;
  padding-right: 1.5rem;
}

.content-dialog {
  padding: 5rem 3rem;
}

.content-submit-dialog {
  height: 300px;
  background: #fff;

  h3 {
    text-align: center;
    padding: 5rem 0 2rem;
  }

  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }
  .btn-back:hover {
    text-decoration: underline;
  }
}

.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}

::v-deep .vth-addr-input {
  border: 1px solid #a2a2a2 !important;
  font-size: 16px !important;
  color: #222 !important;
  box-shadow: none !important;
}
::v-deep .vth-addr-input:focus-visible {
  outline: none !important;
  border: 1px solid #92debe !important;
}
</style>
